import CustomerService from '../services/customer-service';
import useFetch from './useFetch';

function useCustomer(customerId, shortCode, opts) {
  const customerResponse = useFetch(CustomerService.get, { customerId, shortCode }, opts);

  const { data, refetch, applyOptimisticUpdate, loading } = customerResponse;

  return {
    data,
    refetch,
    applyOptimisticUpdate,
    loading,
  };
}
export default useCustomer;
